import {Box} from '@mui/material';
import {FC} from 'react';
import theme from 'src/theme';
import {phoneCardSx} from 'src/components/mobile/mobileDesign.sx';
import {EmptyTableWrapperType} from './EmptyTableWrapper.types';

export const EmptyTableWrapper: FC<EmptyTableWrapperType> = ({children}) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            // Below a desktop the list has no panel around it any more, so "no data" would be an icon
            // and a line of text loose on the page. It gets the card a row would have had: an empty
            // list is still the list, and it should occupy the place the list occupies.
            [theme.breakpoints.down('md')]: {
                ...(phoneCardSx as object),
                height: 'auto',
                minHeight: 160,
                padding: '14px',
            },
        }}
    >
        {children}
    </Box>
);
